// Renders text with *word* segments wrapped in an italic <em>, matching the site's heading style.
export function renderEmphasis(text, emphasisClassName = "text-[#C5A059]") {
  if (!text) return null;
  const parts = String(text).split(/\*(.+?)\*/g);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <em key={`${i}-${part}`} className={emphasisClassName}>
        {part}
      </em>
    ) : (
      part
    )
  );
}
